// --- FILENAME: src/components/data/ProgramData.js ---
// This file separates the data from the presentation logic for the programs section.

export const programData = [
  {
    imgSrc: "https://images.pexels.com/photos/4485023/pexels-photo-4485023.jpeg",
    title: "Marine Protection",
    description: "Our marine life programs focus on protecting endangered species and maintaining biodiversity through research and conservation initiatives."
  },
  {
    imgSrc: "https://images.pexels.com/photos/9034661/pexels-photo-9034661.jpeg",
    title: "Plastic Pollution Reduction",
    description: "Fighting plastic pollution in our oceans and waterways."
  },
  {
    imgSrc: "https://images.pexels.com/photos/6965536/pexels-photo-6965536.jpeg",
    title: "Climate Action",
    description: "Tackling climate change to preserve the ocean's ecosystems."
  },
  {
    imgSrc: "https://th.bing.com/th/id/OIP.uuf0FVxil5ja7aE_Rl7yNQAAAA?rs=1&pid=ImgDetMain",
    title: "Ocean Cleanup",
    description: "We actively organize and promote ocean cleanup projects to remove plastic and other pollutants, restoring the natural beauty of our oceans."
  },
  {
    imgSrc: "https://www.ecomena.org/wp-content/uploads/2014/10/environmental-education.jpg",
    title: "Environmental Education",
    description: "We believe in education as a powerful tool for change. Our education programs help spread awareness about the importance of ocean conservation to all ages."
  }
];
